import React from 'react';

import {
  Card,
  CardContent,
} from '@spaced-out/ui-design-system/lib/components/Card';
import css from './card-children.css';


export const CardChildren = ({children}: {children: React.ReactNode}) => {
  return (
    <Card classNames={{wrapper: css.cardChildren}}>
      <CardContent>
        {/* Children are react components */}
        {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
        {children}
      </CardContent>
    </Card>
  );
};
